import { render } from "./VideoPlayerSideVideoSources.vue?vue&type=template&id=35df96c8&scoped=true"
import script from "./VideoPlayerSideVideoSources.vue?vue&type=script&lang=js"
export * from "./VideoPlayerSideVideoSources.vue?vue&type=script&lang=js"

import "./VideoPlayerSideVideoSources.vue?vue&type=style&index=0&id=35df96c8&scoped=true&lang=css"

import exportComponent from "/Users/tpere/RocketBears/vue-viewer-plugin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35df96c8"]])

export default __exports__